'use client';

import { WebViewScreen } from '@diritto/common/app/webview-header.constant';
import { EventListType } from '@diritto/common/event/constants';
import { EventDto } from '@diritto/common/event/dtos/event.dto';
import { flatItems } from '@diritto/common/utils/array';
import { EventList } from 'app-components/events/EventList';
import { EventTabMenu } from 'app-components/events/EventTabMenu';
import { useSearchParams } from 'next/navigation';
import { useGetEventsInfiniteQuery } from 'queries/events/useGetEventsInfiniteQuery';
import { useMemo } from 'react';
import { Divider } from 'ui-components/common/Divider';
import { InfiniteScrollWrapper } from 'ui-components/common/InfiniteScrollWrapper';
import {
  ContentBodyContainer,
  ContentBodyPaddingContainer,
} from 'ui-components/layout/containers/ContentBodyCenterContainer';
import { MutableHeaderLayout } from 'ui-components/layout/MutableHeaderLayout';
import { useInAppHeader } from 'ui-hooks/useInAppHeader';
import { useInAppStatusBar } from 'ui-hooks/useInAppStatusBar';

interface EventsPageProps {
  isApp?: boolean;
}

export const EventsPage = ({ isApp }: EventsPageProps) => {
  const searchParams = useSearchParams();

  useInAppHeader({ screen: WebViewScreen.Event, title: '이벤트' });
  useInAppStatusBar(WebViewScreen.Event);

  const listType = (searchParams?.get('listType') as EventListType) || EventListType.Progress;

  const { data, hasNextPage, fetchNextPage } = useGetEventsInfiniteQuery({
    listType,
  });

  const { events } = useMemo(
    () => ({
      events: flatItems<EventDto>('events', data?.pages),
    }),
    [data],
  );

  return (
    <MutableHeaderLayout hasTab={false} title="이벤트" isApp={isApp}>
      <ContentBodyContainer className="relative">
        <EventTabMenu />
        <Divider position="bottom" />
      </ContentBodyContainer>
      <ContentBodyPaddingContainer>
        <InfiniteScrollWrapper hasNext={hasNextPage} loadMore={fetchNextPage}>
          {events && (
            <EventList
              events={events}
              emptyText={`${listType === EventListType.Progress ? '아직 진행 중인' : '아직 종료된'} 이벤트가 없어요.`}
            />
          )}
        </InfiniteScrollWrapper>
      </ContentBodyPaddingContainer>
    </MutableHeaderLayout>
  );
};
